function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4699 19.1427V20.8652C10.4699 21.0082 10.5862 21.1252 10.7284 21.1252H12.021C12.1632 21.1252 12.2795 21.0082 12.2795 20.8652V19.1427C12.5463 18.9501 12.7454 18.6774 12.8482 18.3637C12.951 18.05 12.9522 17.7117 12.8516 17.3973C12.751 17.0829 12.5538 16.8087 12.2884 16.6142C12.023 16.4197 11.7031 16.3149 11.3747 16.3149C11.0463 16.3149 10.7264 16.4197 10.461 16.6142C10.1956 16.8087 9.99842 17.0829 9.89783 17.3973C9.79723 17.7117 9.79842 18.05 9.90122 18.3637C10.004 18.6774 10.2031 18.9501 10.4699 19.1427Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7159 11.44H5.55824V4.16C5.55824 3.15575 6.36935 2.34 7.3679 2.34H15.3821C16.3806 2.34 17.1918 3.15575 17.1918 4.16V6.37C17.1918 6.513 17.3081 6.63 17.4503 6.63H19.2599C19.4021 6.63 19.5185 6.513 19.5185 6.37V4.16C19.5185 1.86225 17.6668 0 15.3821 0H7.3679C5.0832 0 3.23153 1.86225 3.23153 4.16V11.44H1.03409C0.462109 11.44 0 11.9047 0 12.48V24.96C0 25.5352 0.462109 26 1.03409 26H21.7159C22.2879 26 22.75 25.5352 22.75 24.96V12.48C22.75 11.9047 22.2879 11.44 21.7159 11.44ZM20.4233 23.66H2.3267V13.78H20.4233V23.66Z",
  fill: "currentColor"
});

var SvgIcStatusDesignOutlined = function SvgIcStatusDesignOutlined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcStatusDesignOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_status_design_outlined.546c653d.svg";
export { ForwardRef as ReactComponent };